var verifyRender = function verifyRender(componentRef) {
  var _componentRef$current;

  return (componentRef === null || componentRef === void 0 ? void 0 : (_componentRef$current = componentRef.current) === null || _componentRef$current === void 0 ? void 0 : _componentRef$current.offsetHeight) || 0 > 0;
};

export { verifyRender };